<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/2 sm:m-0 m-4">
			<vx-card style="background: transparent">
				<div slot="no-body" class="full-page-bg-color" style="background-color: rgba(255, 255, 255, 0.7)">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img src="@/assets/images/pages/loginnew.png" alt="login" class="mx-auto" style="width: 313px" />
							<h4 class="mb-4" style="color: #626262; text-align: center; margin-top: 40px">Sàn giao dịch thương mại điện tử gạo và phụ phẩm ngành gạo theo mô hình kinh tế tuần hoàn</h4>
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="px-8 pt-8 login-tabs-container" style="position: relative">
								<div class="vx-card__title mb-4">
									<h4 class="mb-4">Đăng nhập</h4>
									<!--<p>Hãy đăng nhập để có thể xem thống kê và thông tin phụ phẩm hàng ngày.</p>-->
									<p>Dự án đang trong quá trình nghiên cứu phát triển. Chỉ các đơn vị đã đăng ký tham gia dự án mới có thể truy cập. Vui lòng đăng nhập để tham gia</p>
								</div>

								<div style="padding-top: 20px" id="login-container">
									<login-jwt></login-jwt>
								</div>

								<div style="position: absolute; left: 0; right: 0; bottom: 10px">
									<p style="text-align: center; color: rgba(0, 0, 0, 0.4); font-size: 12px">COPYRIGHT &#9400; Agri Index 2022</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import LoginJwt from "./LoginJWT.vue";

export default {
	components: {
		LoginJwt,
	},
};
</script>

<style lang="scss">
.login-tabs-container {
	min-height: 505px;

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}
</style>
